import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useQueryParams} from 'presentation/pages';
import {getOdontoAvailableTimes} from '../../services/getOdontoAvailableTimes';
import {ODONTO_AVAILABLE_TIMES_STALE_TIME} from './constants';
import {UseGetOdontoAvailableTimesQueryProps} from './types';

export function useGetOdontoAvailableTimesQuery({enabled}: UseGetOdontoAvailableTimesQueryProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {
		SEARCH_PARAMS: {shift, disability},
	} = useQueryParams();

	const availableTimesParams = {
		cdAtendimentoAcessoEspecial: disability,
		cdEspecialidade: Number(bookingData.specialtyCode),
		cdPrestadorJuridico: Number(bookingData.unitCode),
		cdUf: bookingData.ufCode.toUpperCase(),
		nmCidade: bookingData.cityName.toUpperCase(),
		cdSubEspecialidade: bookingData.subSpecialtyCode ? Number(bookingData.subSpecialtyCode) : 0,
		nmBairro: bookingData.odontoUnitDistrictSelected
			? bookingData.odontoUnitDistrictSelected.toUpperCase()
			: undefined,
		dataConsulta: bookingData.dateAt,
		filtroTurno: shift,
	};

	return useQuery({
		queryKey: [QUERY_KEYS.ODONTO_AVAILABLE_TIMES, availableTimesParams],
		queryFn: ({signal}) => getOdontoAvailableTimes({signal, ...availableTimesParams}),
		enabled,
		staleTime: ODONTO_AVAILABLE_TIMES_STALE_TIME,
	});
}
